import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncorrectPermissions = _resolveComponent("IncorrectPermissions")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_FiscalYearReportSearch = _resolveComponent("FiscalYearReportSearch")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ReportExporter = _resolveComponent("ReportExporter")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (!_ctx.canView)
        ? (_openBlock(), _createBlock(_component_IncorrectPermissions, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.canView)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            flat: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                color: "secondary",
                extended: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: "/",
                    custom: ""
                  }, {
                    default: _withCtx(({navigate}) => [
                      _createVNode(_component_v_btn, {
                        onClick: navigate,
                        icon: "",
                        class: "text-white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("mdi-arrow-left-circle", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Post-Program Recidivism Report", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                class: "mx-auto",
                "max-width": "100%",
                style: {"margin-top":"-60px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FiscalYearReportSearch, {
                    "is-searching": _ctx.isSearching,
                    onSearch: _ctx.getReportData,
                    onLoading: _cache[0] || (_cache[0] = val => _ctx.isLoading = val)
                  }, null, 8, ["is-searching", "onSearch"]),
                  (_ctx.isSearching)
                    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (!_ctx.isSearching && !_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                        default: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createElementVNode("h2", {
                            class: "bg-secondary mt-3 pa-3",
                            style: {"text-align":"center"}
                          }, "Summary", -1)),
                          _createVNode(_component_v_data_table, {
                            headers: _ctx.summaryHeaders,
                            items: _ctx.summaryData,
                            density: "compact",
                            class: "elevation-1",
                            "no-data-text": "No results yet"
                          }, _createSlots({ _: 2 }, [
                            (_ctx.summaryData.length <= 10)
                              ? {
                                  name: "bottom",
                                  fn: _withCtx(() => []),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["headers", "items"]),
                          (!_ctx.isSearching && _ctx.summaryData.length > 0)
                            ? (_openBlock(), _createBlock(_component_ReportExporter, {
                                key: 0,
                                items: _ctx.summaryData,
                                title: "In-Program Recidivism Report Summary",
                                filename: "InProgramRecidivismReportSummary",
                                headers: _ctx.summaryHeaders
                              }, null, 8, ["items", "headers"]))
                            : _createCommentVNode("", true),
                          _cache[4] || (_cache[4] = _createElementVNode("h2", {
                            class: "bg-secondary mt-3 pa-3",
                            style: {"text-align":"center"}
                          }, "Details", -1)),
                          _createVNode(_component_v_data_table, {
                            headers: _ctx.headers,
                            items: _ctx.reportData,
                            density: "compact",
                            class: "elevation-1",
                            "no-data-text": "No results found"
                          }, _createSlots({ _: 2 }, [
                            (_ctx.reportData.length <= 10)
                              ? {
                                  name: "bottom",
                                  fn: _withCtx(() => []),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["headers", "items"]),
                          (!_ctx.isSearching && _ctx.reportData.length > 0)
                            ? (_openBlock(), _createBlock(_component_ReportExporter, {
                                key: 1,
                                items: _ctx.reportData,
                                title: "In-Program Recidivism Report",
                                filename: "InProgramRecidivismReport",
                                headers: _ctx.headers
                              }, null, 8, ["items", "headers"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}